import css from "styled-jsx/css";

export const componentStyles = css`
  .boards-and-quotes-carousel-component {
    .boards-carousel-wrapper {
      position: relative;
    }

    .people-carousel-wrapper {
      margin-top: 60px;
    }
  }
`;
